import React from "react";
import { useTranslation } from "react-i18next";
import Eyebrow from "../../atoms/Eyebrow/Eyebrow.styled";
import Button from "../../atoms/Button/Button.component";
import Icon, { IconName } from "../../atoms/Icon/Icon.component";
import FaqList from "../../atoms/FaqList/FaqList.component";
import { useDemoDialog } from "../../molecules/DemoDialog/DemoDialog.context";
import { getTrustStatementsTranslated } from "../../../constants/trust";
import { getLandingQuestions } from "../../../constants/landing-faqs";
import { newLineText } from "../../../utils/utils";
import {
  FaqDescription,
  FaqGrid,
  FaqLead,
  FaqTitle,
  TrustBar,
  TrustFaqsSection,
  TrustFaqsWrapper,
  TrustItem,
} from "./TrustFaqs.styled";

const TrustFaqs = () => {
  const { t } = useTranslation();
  const { openDemoDialog } = useDemoDialog();
  const statements = getTrustStatementsTranslated(t);
  const questions = getLandingQuestions(t);

  return (
    <TrustFaqsSection id="faqs" aria-labelledby="faq-title">
      <TrustFaqsWrapper>
        <TrustBar>
          {statements.map((statement) => (
            <TrustItem key={statement.id}>
              <Icon name={statement.icon as IconName} />
              <span>{statement.label}</span>
            </TrustItem>
          ))}
        </TrustBar>
        <FaqGrid>
          <FaqLead>
            <Eyebrow>{t("landing.faqs.eyebrow")}</Eyebrow>
            <FaqTitle id="faq-title">
              {newLineText(t("landing.faqs.title")).map((line) => (
                <span key={line}>{line}</span>
              ))}
            </FaqTitle>
            <FaqDescription>
              {newLineText(t("landing.faqs.description")).map((line) => (
                <span key={line}>{line}</span>
              ))}
            </FaqDescription>
            <Button variant="outline" onClick={() => openDemoDialog()}>
              {t("landing.faqs.cta")}
            </Button>
          </FaqLead>
          <FaqList questions={questions} />
        </FaqGrid>
      </TrustFaqsWrapper>
    </TrustFaqsSection>
  );
};

export default TrustFaqs;
